import { Badge } from "antd";
import {
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseCircleTwoTone
} from "@ant-design/icons";

const statusBadgeIcon = {
  success: <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "12px" }} />,
  warning: <ExclamationCircleTwoTone twoToneColor="#faad14" style={{ fontSize: "12px" }} />,
  error: <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: "12px" }} />,
};

const CustomBadge = ({ status = "success", icon, ...rest }) => {
  return (
    <div style={{ display: "inline-block", position: "relative" }} {...rest}>
      <Badge 
        count={statusBadgeIcon[status]} 
        offset={[0, 0]} 
        style={{ background: "transparent" }}
      >
        {icon}
      </Badge>
    </div>
  );
};


export default CustomBadge;
